import { Link } from 'react-router-dom'
import { getMessage } from '@/utils/messages'

export function NotFoundPage() {
  return (
    <main className="flex-1 flex flex-col items-center justify-center px-8 py-16 text-center">
      <div
        className="text-[80px] mb-6 opacity-30"
        style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}
      >
        404
      </div>
      <h1
        className="text-[24px] mb-2 text-[var(--text)]"
        style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}
      >
        {getMessage('not_found.title')}
      </h1>
      <p className="text-[13px] text-[var(--text-muted)] mb-8 font-mono max-w-sm">
        {getMessage('not_found.description')}
      </p>
      <Link
        to="/"
        className="px-5 py-[10px] rounded-[var(--radius-sm)] text-white font-mono text-[12px] font-medium hover:opacity-90 transition-opacity"
        style={{ background: 'linear-gradient(135deg, var(--accent), #2563eb)' }}
      >
        {getMessage('not_found.button_back')}
      </Link>
    </main>
  )
}
